<template>
  <section>
    <div>
      <h3>
        Strom aus Erneuerbaren
        <Popper placement="bottom" offset-distance="5" arrow="true" class="popover">
          <template #content><span v-html="store.popupElec"></span></template>
          <button class="info" type="button"></button>
        </Popper>
      </h3>
      <button class="toggle" v-on:click="toggleFunction"></button>
    </div>
    <ElecYesterday></ElecYesterday>
    <div class="toggled" ref="toggleElement">
      <ElecMonth :dataElecMonth="dataElecMonth"></ElecMonth>
      <EleAverage :dataElecAverageBig="dataElecAverageBig" :dataElecAverage="dataElecAverage"></EleAverage>
    </div>
  </section>
</template>

<script>
import { store } from "../store";

import ElecYesterday from "./elecYesterday.vue";
import ElecMonth from "./elecMonth.vue";
import EleAverage from "./elecAverage.vue";
import Popper from "vue3-popper";

export default {
  components: {
    ElecYesterday,
    ElecMonth,
    EleAverage,
    Popper,
  },
  data() {
    return {
      store,
      dataElecMonth: [],
      dataElecYesterday: [],
      dataElecAverageBig: "",
    };
  },
  methods: {
    toggleFunction() {
      this.$emit("child-event");
    },
  },
  mounted() {
    fetch(store.urlElec)
      .then((response) => response.json())
      .then((data) => {
        //this.posts = data
        //console.log("data Elec", data);
        store.dataElecYesterday = data.bigNumber_EE;
        this.dataElecAverageBig = data.bigNumber_pie;
        this.dataElecMonth = data.balken_EE;
        this.dataElecAverage = data.pie_chart;
      });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
